module.exports = __webpack_public_path__ + "img/file-empty.ca8216e6.png";